import type { ISearchFilterIdItemDto } from '~/dtos/hub/hub.models.generated';
import { FilterEntriesItem } from '~/features/catalog/components/filter/FilterEntriesItem';
import type { SelectableFilterItem } from '~/features/catalog/components/filter/MultiSelectionItemFilter';
import { cn } from '~/common/utils/styleUtil';
import type { IVirtualBaseListRenderItemProps} from '~/common/components/VirtualBaseList';
import { VirtualBaseList } from '~/common/components/VirtualBaseList';

interface FilterEntriesListProps {
  selectableItems: SelectableFilterItem<ISearchFilterIdItemDto>[];
  onItemSelectionChanged: (id: number) => void;
  height: number | string;
}

export function FilterEntriesList({ selectableItems, onItemSelectionChanged, height }: Readonly<FilterEntriesListProps>) {
  const renderItem = (data: IVirtualBaseListRenderItemProps) => {
    const filterItem = selectableItems[data.index];
    const nextFilterItem = selectableItems[data.index + 1];
    const showBorder = filterItem.item.isFeatured && nextFilterItem && !nextFilterItem.item.isFeatured;

    return (
      <div key={filterItem.item.id} className={cn(showBorder && 'border-b border-gray-200')}>
        <FilterEntriesItem selectableItem={filterItem} onItemSelectionChanged={onItemSelectionChanged} />
      </div>
    );
  };

  return (
    <VirtualBaseList
      className={'overflow-auto desktop:overflow-hidden'}
      itemCount={selectableItems.length}
      renderItem={(data: IVirtualBaseListRenderItemProps) => renderItem(data)}
      overscan={5}
      useWindowScroll={false}
      height={height}
    />
  );
}
